(()=>{
  const nav=document.querySelector('[data-fa-blog-sticky-nav]');
  let frame=0;

  const visibleHeaderBottom=()=>{
    const candidates=[
      document.querySelector('sticky-header'),
      document.querySelector('.header-wrapper'),
      document.querySelector('header.header')
    ].filter(Boolean);
    let bottom=0;
    candidates.forEach(node=>{
      const rect=node.getBoundingClientRect();
      const style=getComputedStyle(node);
      if(style.display==='none'||style.visibility==='hidden'||rect.height<=0)return;
      if(rect.bottom>0&&rect.top<=2){
        bottom=Math.max(bottom,Math.ceil(rect.bottom));
      }
    });
    return Math.max(0,bottom);
  };

  const syncSticky=()=>{
    const top=visibleHeaderBottom();
    document.documentElement.style.setProperty('--fa-blog-sticky-top',`${top}px`);

    if(nav){
      const rect=nav.getBoundingClientRect();
      nav.classList.toggle('is-stuck',window.scrollY>0&&rect.top<=top+1);

      const threshold=top+nav.offsetHeight+28;
      let current=null;
      nav.querySelectorAll('a[href^="#"]').forEach(link=>{
        const id=link.getAttribute('href').slice(1);
        const target=id&&document.getElementById(id);
        if(target&&target.getBoundingClientRect().top<=threshold)current=link;
      });
      nav.querySelectorAll('a[href^="#"]').forEach(link=>{
        link.classList.toggle('is-section-active',link===current);
      });
    }
    frame=0;
  };

  const requestStickySync=()=>{
    if(!frame)frame=requestAnimationFrame(syncSticky);
  };

  const revealRelevantTab=()=>{
    if(!nav)return;
    const track=nav.querySelector('.fa-blog-topic-nav__track');
    if(!track)return;
    const hash=window.location.hash;
    const hashLink=hash?Array.from(track.querySelectorAll('a[href^="#"]')).find(link=>link.getAttribute('href')===hash):null;
    const target=hashLink||track.querySelector('.is-active');
    if(!target)return;
    const left=target.offsetLeft-(track.clientWidth-target.offsetWidth)/2;
    track.scrollTo({left:Math.max(0,left),behavior:'auto'});
  };

  const initCarousels=root=>root.querySelectorAll('[data-fa-carousel-wrap]').forEach(w=>{
    const t=w.querySelector('[data-fa-carousel]'),
      s=w.closest('.fa-blog-products')||w.parentElement,
      p=s&&s.querySelector('[data-fa-carousel-prev]'),
      n=s&&s.querySelector('[data-fa-carousel-next]');
    if(!t||!p||!n)return;
    const step=()=>Math.max(t.clientWidth*.82,260);
    p.addEventListener('click',()=>t.scrollBy({left:-step(),behavior:'smooth'}));
    n.addEventListener('click',()=>t.scrollBy({left:step(),behavior:'smooth'}));
    const sync=()=>{
      const overflow=t.scrollWidth>t.clientWidth+6;
      p.hidden=!overflow;
      n.hidden=!overflow;
      p.disabled=t.scrollLeft<=4;
      n.disabled=t.scrollLeft+t.clientWidth>=t.scrollWidth-4;
    };
    t.addEventListener('scroll',sync,{passive:true});
    addEventListener('resize',sync,{passive:true});
    sync();
  });

  const boot=()=>{
    document.querySelectorAll('[data-fa-blog-landing]').forEach(initCarousels);
    revealRelevantTab();
    syncSticky();
  };

  addEventListener('scroll',requestStickySync,{passive:true});
  addEventListener('resize',requestStickySync,{passive:true});
  addEventListener('hashchange',()=>{revealRelevantTab();requestStickySync()},{passive:true});
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot,{once:true}):boot();
})();
